import { Component, Input, OnInit } from '@angular/core';
import { formatPounds } from 'src/app/components/shared/pipes/app-pounds-pipe';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';

@Component({
  selector: 'app-apg-quick-quote-notes',
  templateUrl: './apg-quick-quote-notes.component.html',
  styleUrls: ['./apg-quick-quote-notes.component.scss'],
})
export class ApgQuickQuoteNotesComponent implements OnInit {

  @Input() quickQuote: QQQuestionnaireViewModel;
  @Input() policyInfo = true;
  @Input() contactUs = true;
  @Input() documentLinks = true;
  @Input() policyBenefits = true;

  keys: { policyInfo: string, policyBenefits: string, documentLinks: string };
  templateData: any;

  constructor(
  ) { }

  ngOnInit() {    
    const hasCI = Array.from(this.quickQuote.answers)
    .filter(([key, value]) => key.startsWith('PolicyType_') && value?.endsWith('-CI'))
    .length > 0;
    
    this.keys = this.getPolicyContentKeys(hasCI, this.quickQuote.answersObject['TypeOfPolicy_1']);
    this.templateData = { SumAssured: formatPounds(this.getSumAssured(hasCI)) };
  }

  getPolicyContentKeys(hasIllnessCover: boolean, typeOfPolicy: 'SINGLE' | 'DUAL') {

    let policyInfoKey = typeOfPolicy;
    if (hasIllnessCover)
      policyInfoKey += `_CI`;

    let documentLinks = "QuickQuoteSummary.DocumentLinks";
    if (hasIllnessCover)
      documentLinks += `_CI`;

    return {
      policyInfo: `QuickQuoteSummary.${policyInfoKey}`,
      policyBenefits: "QuickQuoteSummary.PolicyBenefits",
      documentLinks
    };
  }
  
  getSumAssured(hasIllnessCover: boolean)
  {
    if (!hasIllnessCover || !this.quickQuote.answersObject[`ProtectionLevel_2`]) {
      return this.quickQuote.answersObject['ProtectionLevel_1'];
    }
    
    var sumAssured1 = parseInt(this.quickQuote.answersObject[`ProtectionLevel_1`]);
    var sumAssured2 = parseInt(this.quickQuote.answersObject[`ProtectionLevel_2`]);
    return sumAssured1 + sumAssured2;
  }

}
